'use client';
import { create } from 'zustand';
import {
  ProfileSkillLevelsArraySchema,
  InstrumentArraySchema,
  SkillLevelsArraySchema,
} from '../types';
import { ActionFeedbackProps } from '../../ui/shared/module-actions-feedback';

export enum InstrumentsLoading {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}

type SubscriptionState = {
  actionFeedback: ActionFeedbackProps | null;
  instruments: InstrumentArraySchema | null;
  profileSkillLevels: ProfileSkillLevelsArraySchema | null;
  skillLevelsOptions: SkillLevelsArraySchema | null;
  error: Error | null;
  isLoading: InstrumentsLoading | null;
  setInstruments: (instruments: InstrumentArraySchema | null) => void;
  setActionFeedback: (feedback: ActionFeedbackProps | null) => void;
  setProfileSkillLevels: (profileSkillLevels: ProfileSkillLevelsArraySchema | null) => void;
  setSkillLevelsOptions: (cs: SkillLevelsArraySchema | null) => void;
  setIsLoading: (status: InstrumentsLoading | null) => void;
  setError: (error: Error | null) => void;
  resetStore: () => void;
};

const initialState: Omit<
  SubscriptionState,
  | 'setInstruments'
  | 'setProfileSkillLevels'
  | 'setSkillLevelsOptions'
  | 'resetStore'
  | 'setActionFeedback'
  | 'setIsLoading'
  | 'setError'
> = {
  actionFeedback: null,
  error: null,
  isLoading: null,
  instruments: null,
  profileSkillLevels: null,
  skillLevelsOptions: null,
};

export const useInstrumentsStore = create<SubscriptionState>((set) => ({
  ...initialState,
  setIsLoading: (isLoading: InstrumentsLoading | null) => set({ isLoading }),
  setError: (error: Error | null) => set({ error }),
  setInstruments: (instruments) => set({ instruments }),
  setProfileSkillLevels: (profileSkillLevels) => set({ profileSkillLevels }),
  setSkillLevelsOptions: (skillLevelsOptions) => set({ skillLevelsOptions }),
  setActionFeedback: (actionFeedback) => set({ actionFeedback }),
  resetStore: () => set(initialState),
}));
